import { useEffect } from "react";
import { useQuery } from "react-query";
import { api } from "services/api";
import { RealEstateUser } from "types/RealEstate";
import { handleRequestError } from "utils/Request";

async function fetchRealEstateUsers(realEstateId: string): Promise<RealEstateUser[]> {
  const { data } = await api.get(`/tecimob/real-estates/${realEstateId}/users`);
  return data;
}

export function useRealEstateUsers(realEstateId: string | null) {
  const query = useQuery(
    ['real-estate-users', realEstateId],
    () => fetchRealEstateUsers(realEstateId as string),
    {
      enabled: !!realEstateId,
    }
  );

  useEffect(() => {
    if (!query.isError) return;
    handleRequestError(query.error, 'Um erro ocorreu ao listar os usuários da imobiliária. Por favor, tente novamente!');
  }, [query.isError, query.error]);

  return query;
}
